export default __webpack_public_path__ + "static/media/prbicon_Retainer.97a23200.svg";